import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionRepository } from '@app-core/state/session.repository';
import { map } from 'rxjs';
import { RoutePaths } from 'src/app/routes/route-paths.enum';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const sessionRepo = inject(SessionRepository);

  return sessionRepo.isLoggedIn$.pipe(
    map(isLoggedIn => {
      if (isLoggedIn) return true;

      // if not logged in we want to save the route that the user wanted to go to
      sessionRepo.setStoreProp('savedRoute', state.url);
      router.navigate([`/${RoutePaths.Login}`]);

      return false;
    }),
  );
};
